import apiClient from './apiClient';
import createCrudApi from './createCrudApi';

// Инициализируем основной клиент без базового префикса
const promosClient = apiClient('');

// Создаём CRUD API для /promos
const PromosApi = createCrudApi(promosClient, 'promos');

// Отдельный объект для пользовательских промо
const UserPromos = {
    async myPromos() {
        return promosClient.get('promos/my');
    },
    async subPromos(){
        return promosClient.get('user-promos/my')
    },
    // Подписаться на промо
    async subscribe(promoId) {
        return promosClient.post(`user-promos/subscribe/${promoId}`);
    },
    // Отписаться от промо
    async unsubscribe(promoId) {
        return promosClient.delete(`user-promos/unsubscribe/${promoId}`);
    },
    // Проверить подписан ли на промо (через список подписок)
    async isSubscribed(promoId) {
        const subs = await promosClient.get('user-promos/my');
        const list = subs.data || subs || [];
        const pid = Number(promoId);
        console.log('[isSubscribed] checking promoId:', pid, 'in list:', list);
        return list.some(sub => {
            const subPromoId = Number(sub.promoId || sub.promo?.id);
            return subPromoId === pid;
        });
    }
};

async function startPromo(id) {
    const res = await promosClient.post(`promos/start/${id}`);
    return res.data;
}

export default {
    ...PromosApi,
    UserPromos,
    startPromo,
};
